import gql from 'graphql-tag';

export const FETCH_APPOINTMENTS_ORGANIZATION_CONFIG = gql`
  query {
    organization(clientType: PATIENT) {
      config {
        generalConfig {
          patientEmail
        }
      }
    }
  }
`;
